import { Collapse, Space, Typography} from 'antd';
import React from 'react';
const { Paragraph, Text } = Typography;

const ValidationErrors = ({ errors }: { errors: any }) => {
    const handleMetadataErrors = (metadata: any, prefix: string) => 
        Object.entries(metadata).map(([field, error]) => <><Text strong>{prefix}</Text> → <Text strong>{field}</Text>: <Text italic>{String(error)}</Text></>);

    const handleServiceItemErrors = (serviceItemData: any, appName: string, serviceName: string, serviceItemName: string) =>
        Object.entries(serviceItemData).map(([field, error]) => 
            <>{<Text strong>{appName}</Text>} → {<Text strong>{serviceName}</Text>} → {<Text strong>{serviceItemName}</Text>} → {<Text strong>{field}</Text>}: <Text italic>{String(error)}</Text></>);

    const handleServiceErrors = (services: any, appName: string) => {
        const errors: (string | JSX.Element)[] = [];
        
        Object.entries(services).forEach(([serviceName, serviceData]: [string, any]) => {
            if (serviceName === "metadata") {
                errors.push(...handleMetadataErrors(serviceData, `${appName} → Metadata`));
            } else if (serviceName === "general") {
                errors.push(<>{appName} → {String(serviceData)}</>);
            } else if (typeof serviceData === 'object' && serviceData !== null && "state" in serviceData) {
                errors.push(<>{appName} → {serviceName} → {String(serviceData.state)}</>);
            } else if (typeof serviceData === 'string') {
                errors.push(<>{appName} → {serviceName} → {String(serviceData)}</>);
            } else {
                Object.entries(serviceData).forEach(([serviceItemName, serviceItemData]) => {
                    errors.push(...handleServiceItemErrors(serviceItemData, appName, serviceName, serviceItemName));
                });
            }
        });
        
        return errors;
    };

    const extractErrors = (jsonResponse: any) => {
        const errors: (string | JSX.Element)[] = [];

        Object.entries(jsonResponse).forEach(([teamName, teamData]: [string, any]) => {
            if (["metadata", "general"].includes(teamName)) {
                //metadata and general errors returned as strings not actually teamdata
                errors.push(<>{String(teamData)}</>);
                return;
            }

            Object.entries(teamData).forEach(([appName, appData]: [string, any]) => {
                if (appName === "metadata") {
                    errors.push(...handleMetadataErrors(appData, "Team Metadata"));
                } else if (appName === "general") {
                    errors.push(<>Team → {String(appData)}</>);
                } else {
                    errors.push(...handleServiceErrors(appData, appName));
                }
            });
        });

        return errors;
    };

    const generateList = (errors: any) => {
        const extractedErrors = extractErrors(errors)
        return (
            <Paragraph>
                <ul style={{textAlign:"left"}}>
                    {extractedErrors.map((err, index) => <li key={index}>{err}</li>)}
                </ul>
            </Paragraph>
        )
    }
    return (
        <Space orientation="vertical" style={{margin: "5px"}}>
            <Collapse bordered={false} style={{backgroundColor: "#fff2f0", borderColor:"#ffccc7", width: "500px", marginBottom:"5px"}} items={[{
                key: '1',
                label: <><Text>Validation Failed</Text></>,
                children: generateList(errors),
            }]} />
        </Space>
    );
};

export default ValidationErrors;
